/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllSupportPlans = (state) => values(get(state, ['supportPlans', 'items']));

export const requestingSupportPlans = (state) => get(state, ['supportPlans', 'requesting']);

export const errorRequestingSupportPlans = (state) => get(state, ['supportPlans', 'error']);